import { render, staticRenderFns } from "./modalProductoDesconocido.vue?vue&type=template&id=a39deeda"
import script from "./modalProductoDesconocido.vue?vue&type=script&lang=js"
export * from "./modalProductoDesconocido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports